import * as PIXI from "pixi.js";

export default class UIBaseComponent extends PIXI.Container {

    constructor() {
        super()
    }

    show() {
        this.visible = true
    }

    hide() {
        this.visible = false
    }

}